/* dz.js – Abläufe der dz-*-Sections (Demenzuhr, Aufbau nach Lymphoria):
   Aufklapp-Zeilen, Slider mit Pfeilen und Punkten, Mengen-Karten (koppeln an
   das Warenkorb-Formular der Buybox und an den Angebots-Kasten) und die Kaufleiste unten. */
(function () {
  if (window.dzInit) return;
  window.dzInit = true;

  /* Aufklappen: [data-dz-acc] – ein Klick auf .dz-acc-q öffnet/schließt */
  document.addEventListener('click', function (ev) {
    var q = ev.target.closest && ev.target.closest('.dz-acc-q');
    if (q) {
      var item = q.closest('.dz-acc-item');
      if (!item) return;
      var open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }

    /* Slider-Pfeile */
    var nav = ev.target.closest && ev.target.closest('[data-dz-slide]');
    if (nav) {
      var track = document.getElementById(nav.getAttribute('aria-controls'));
      if (!track || !track.firstElementChild) return;
      var step = track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
      track.scrollBy({ left: nav.getAttribute('data-dz-slide') === 'prev' ? -step : step, behavior: 'smooth' });
      return;
    }

    /* Angebots-Button der Wiederholung: Menge in die Buybox übernehmen und dort absenden */
    var offer = ev.target.closest && ev.target.closest('[data-dz-offer-buy]');
    if (offer) {
      var box = offer.closest('[data-dz-offer]');
      var picked = box && box.querySelector('input[type=radio]:checked');
      if (picked) setQty(picked.value);
      var main = mainSubmit();
      if (main && !main.disabled && main.getAttribute('aria-disabled') !== 'true') main.click();
      return;
    }

    /* Kaufleiste: zur Buybox scrollen */
    var go = ev.target.closest && ev.target.closest('[data-dz-scroll-buy]');
    if (go) {
      var target = document.querySelector('[data-dz-qty-main]') || document.querySelector('.product-form__submit');
      if (target) { ev.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  });

  /* Mengen-Karten: Wert in das versteckte quantity-Feld, Beschriftung des Buttons anpassen */
  function mainSubmit() {
    return document.querySelector('.product__info-container .product-form__submit');
  }
  function setQty(val) {
    document.querySelectorAll('[data-dz-qty-input]').forEach(function (inp) { inp.value = val; });
    document.querySelectorAll('[data-dz-qty] input[type=radio]').forEach(function (r) { r.checked = (r.value === String(val)); });
    var picked = document.querySelector('[data-dz-qty-main] input[type=radio]:checked');
    var label = picked && picked.getAttribute('data-label');
    var btn = mainSubmit();
    var span = btn && btn.querySelector('span');
    if (span && label && !btn.disabled) span.textContent = label;
    if (picked) {
      document.querySelectorAll('[data-dz-ob-total], [data-dz-ob-price]').forEach(function (el) { el.textContent = picked.getAttribute('data-total'); });
      document.querySelectorAll('[data-dz-ob-note]').forEach(function (el) { el.textContent = picked.getAttribute('data-note'); });
    }
    document.querySelectorAll('[data-dz-offer-label]').forEach(function (el) {
      var b = el.closest('button');
      if (label && !(b && b.disabled)) el.textContent = label;
    });
  }
  document.addEventListener('change', function (ev) {
    var r = ev.target;
    if (r && r.type === 'radio' && r.closest('[data-dz-qty]')) setQty(r.value);
  });

  /* Punkte unter Slidern */
  function initDots() {
    document.querySelectorAll('[data-dz-dots]').forEach(function (dots) {
      var track = document.getElementById(dots.getAttribute('data-dz-dots'));
      if (!track || track.dzDots) return;
      track.dzDots = true;
      var ticking = false;
      function update() {
        ticking = false;
        var card = track.firstElementChild;
        if (!card) return;
        var step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
        var idx = Math.round(track.scrollLeft / step);
        Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === idx); });
      }
      track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    });
  }

  /* Kaufleiste unten: sichtbar, sobald der Buybox-Button oben aus dem Bild ist */
  function initSticky() {
    var bar = document.querySelector('[data-dz-sticky]');
    var btn = mainSubmit();
    if (!bar || !btn) return;
    if (bar.parentElement !== document.body) document.body.appendChild(bar);
    function check() {
      var r = btn.getBoundingClientRect();
      var footer = document.querySelector('.footer, footer');
      var nearEnd = footer && footer.getBoundingClientRect().top < window.innerHeight;
      bar.classList.toggle('is-on', r.bottom < 0 && !nearEnd);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  function init() {
    initDots();
    initSticky();
    var picked = document.querySelector('[data-dz-qty-main] input[type=radio]:checked');
    if (picked) setQty(picked.value);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initDots(); });
})();
